module.exports = __webpack_public_path__ + "static/media/mucosal.03fdb3b6.png";